import { ADD_LOADED_COMPONENT } from './constants';

export const addLoadedComponentAction = component => ({
  type: ADD_LOADED_COMPONENT,
  payload: component,
});
